import React from 'react';
import { FramePlaceholderBoundary } from './FramePlaceholderBoundary';
import { OrderLineItem } from './OrderLineItem';
import { usePrototype } from '../../contexts/PrototypeContext';
import { siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';

/**
 * VISUAL PLACEHOLDER — native Website Forge ORDER CONFIRMATION frame output.
 *
 * At integration, render the EXISTING native confirmation output, which supplies the
 * real order number, line items, shipping, tax and totals. Grey bars mark values the
 * native output provides; nothing here represents a real order.
 */
export function WfOrderConfirmationFramePreview() {
  const {
    orderedQuantity
  } = usePrototype();
  const subtotal = siteConfig.product.samplePrice * orderedQuantity;
  return <FramePlaceholderBoundary frame="WfOrderConfirmationFramePreview" data-id="element-102" data-mp="3nkrq7pm2unks">
      <div className="border-t border-ink pt-6" data-id="element-103" data-mp="3nhvtu5pvo6yg">
        <dl className="grid gap-6 border-b border-line pb-6 sm:grid-cols-2" data-id="element-104" data-mp="3ik43hg4vsswd">
          <div data-id="element-105" data-mp="x5rq686beihs">
            <dt className="text-[13px] text-ink-muted" data-id="element-106" data-mp="x7cp09znwnlg">Order number</dt>
            <dd className="mt-2" data-id="element-107" data-mp="1254ih8fyghrr">
              <span aria-label="Shown on your confirmation" className="block h-5 w-36 rounded-sm bg-canvas-deep" data-id="element-108" data-mp="124352xbgvj6v" />
            </dd>
          </div>
          <div data-id="element-109" data-mp="t4oelxvav8md">
            <dt className="text-[13px] text-ink-muted" data-id="element-110" data-mp="t46l3900v8i5">Delivery to</dt>
            <dd className="mt-2 space-y-2" data-id="element-111" data-mp="t6izjc6kn0qg">
              <span aria-label="Shown on your confirmation" className="block h-4 w-44 rounded-sm bg-canvas-deep" data-id="element-112" data-mp="efjxyl45lcgd" />
              <span aria-hidden="true" className="block h-4 w-32 rounded-sm bg-canvas-deep" data-id="element-113" data-mp="j7a8ar33c07s" />
            </dd>
          </div>
        </dl>
        <div className="py-6" data-id="element-114" data-mp="5dakbmdl92yr">
          <OrderLineItem quantity={orderedQuantity} compact data-id="element-115" data-mp="9g7aby5gk1cq" />
        </div>
        <dl className="space-y-3 border-t border-line pt-5 text-[15px]" data-id="element-116" data-mp="3rmbudyfk9k05">
          <div className="flex justify-between" data-id="element-117" data-mp="3rn3of4tif9ob">
            <dt className="text-ink-muted" data-id="element-118" data-mp="gk5119lybee">Subtotal</dt>
            <dd className="tabular-nums text-ink" data-id="element-119" data-mp="i3losz6eogp">{formatPrice(subtotal)}</dd>
          </div>
          <div className="flex justify-between" data-id="element-120" data-mp="226hp6jr4mcvy">
            <dt className="text-ink-muted" data-id="element-121" data-mp="1xdycdp09jls7">Shipping</dt>
            <dd className="text-ink" data-id="element-122" data-mp="1xcdepqinjmq4">Free</dd>
          </div>
          {['Tax', 'Total'].map(label => <div key={label} className="flex items-center justify-between" data-id="element-123" data-mp="1taid0kwt77bt">
              <dt className={label === 'Total' ? 'font-medium text-ink' : 'text-ink-muted'} data-id="element-124" data-mp="1ofmm5o3b6q0a">{label}</dt>
              <dd data-id="element-125" data-mp="2l39aszu55436">
                <span aria-label="Shown on your confirmation" className="block h-4 w-16 rounded-sm bg-canvas-deep" data-id="element-126" data-mp="2l1pu584kor0v" />
              </dd>
            </div>)}
        </dl>
      </div>
    </FramePlaceholderBoundary>;
}